(function () {
  var DESKTOP_BREAKPOINT = 960;
  var HEADER_SELECTOR = '[data-section-type="header"]';
  var INNER_WRAPPER_SELECTOR = '.header__inner-wrapper';
  var observers = [];
  var rafId = null;
  var breakpointMedia = window.matchMedia('(min-width: ' + DESKTOP_BREAKPOINT + 'px)');

  var getHeader = function () {
    return document.querySelector(HEADER_SELECTOR);
  };

  var getHeaderInnerWrapper = function () {
    var header = getHeader();
    return header ? header.querySelector(INNER_WRAPPER_SELECTOR) : null;
  };

  var getVerticalPadding = function (element) {
    if (!element) {
      return 0;
    }

    var styles = window.getComputedStyle(element);

    return parseFloat(styles.paddingTop) + parseFloat(styles.paddingBottom);
  };

  var measureDesktopInnerWrapperHeight = function (innerWrapper) {
    var desktopContent = innerWrapper.querySelector('.header__content-desktop');
    var inner = innerWrapper.querySelector('.header__inner');

    if (desktopContent) {
      return Math.ceil(
        desktopContent.offsetHeight +
          getVerticalPadding(inner) +
          getVerticalPadding(innerWrapper)
      );
    }

    if (inner) {
      return Math.ceil(inner.offsetHeight + getVerticalPadding(innerWrapper));
    }

    return Math.ceil(innerWrapper.offsetHeight);
  };

  var measureHeaderHeight = function () {
    var innerWrapper = getHeaderInnerWrapper();

    if (!innerWrapper) {
      return 0;
    }

    if (breakpointMedia.matches) {
      return measureDesktopInnerWrapperHeight(innerWrapper);
    }

    return Math.ceil(innerWrapper.offsetHeight);
  };

  var updateHeaderHeight = function () {
    var height = measureHeaderHeight();
    var root = document.documentElement;
    var current = parseFloat(root.style.getPropertyValue('--header-height')) || 0;

    root.style.setProperty('--header-height', height + 'px');

    if (current !== height) {
      window.dispatchEvent(
        new CustomEvent('header-height:change', {
          detail: { height: height },
        })
      );
    }
  };

  var scheduleUpdate = function () {
    if (rafId) {
      return;
    }

    rafId = window.requestAnimationFrame(function () {
      rafId = null;
      updateHeaderHeight();
    });
  };

  var observeElement = function (element) {
    if (!element || typeof ResizeObserver === 'undefined') {
      return;
    }

    var observer = new ResizeObserver(scheduleUpdate);
    observer.observe(element);
    observers.push(observer);
  };

  var bindObservers = function () {
    observers.forEach(function (observer) {
      observer.disconnect();
    });
    observers = [];

    var innerWrapper = getHeaderInnerWrapper();

    if (!innerWrapper) {
      return;
    }

    observeElement(innerWrapper);

    if (breakpointMedia.matches) {
      observeElement(innerWrapper.querySelector('.header__content-desktop'));
      observeElement(innerWrapper.querySelector('.header__inner'));
    }
  };

  var init = function () {
    bindObservers();
    updateHeaderHeight();

    window.addEventListener('resize', scheduleUpdate, { passive: true });
    window.addEventListener('orientationchange', scheduleUpdate, { passive: true });
    window.addEventListener('load', scheduleUpdate, { passive: true });
    breakpointMedia.addEventListener('change', function () {
      bindObservers();
      scheduleUpdate();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (
      event.target.querySelector(HEADER_SELECTOR) ||
      event.target.querySelector(INNER_WRAPPER_SELECTOR)
    ) {
      bindObservers();
      scheduleUpdate();
    }
  });

  window.__customHeaderHeight = {
    refresh: updateHeaderHeight,
  };
})();
